import router from '../router'
// import apis from '@/api/interface/index'
// // updateRead, behavior
import { insertVistor } from '../api/interface/common.js'
import store from '../store'
import wxService from '@/api/wxService'

router.beforeEach((to, from, next) => {
    // to and from are both route objects. must call `next`.
    next()
})

router.afterEach((to, from) => {
    // const _url = window.location.origin + '/20syds' + from.fullPath
    window.scroll(0, 0)
    document.title = to.meta.pageTitle


  // 分享处理
  if (store.state.app.isMobile && to.name!='dljnhs_detail') {
    var currentTitle,currentDetail 
    currentTitle= to.name+'M'
    currentDetail=to.name+'F'    
    var shareConfig = {}
    shareConfig.currentTitle =  store.state.app.shareList[currentTitle]
    shareConfig.share_url = window.location.href
    shareConfig.currentCover = window.location.origin + '/25dlfy/' +  store.state.app.shareList.imgUrl
    shareConfig.currentDetail = store.state.app.shareList[currentDetail]
    console.log('分享参数：', shareConfig)
    wxService.setWXConfig(shareConfig)
  }

    /**
     * 录入访客信息
     */
    const visitParams = {}
    visitParams.menusId = ''
    visitParams.visitTitle = store.state.app.shareList.indeM
    setVistor(visitParams)

    function setVistor(visitParams) {
        visitParams.visitorCity = store.state.app.cityName
        visitParams.visitorLatitude = store.state.app.latitude
        visitParams.visitorLongitude = store.state.app.longitude
        visitParams.visitUrl = window.location.href
        visitParams.visitorClient = store.state.app.device // 设备信息：0-安卓web；1-安卓app；2-苹果web；3- 苹果app；4- pc
        insertVistor(visitParams)
    }
})


// WEBPACK FOOTER //
// ./src/http/routerChange.js